module.exports = __webpack_public_path__ + "img/academy-colored.62665a5.svg";